function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 17V1h-8v19l8-3zm-9.99-6L9 17 .997 20v-9H9.01zM9 29H.997v-5L9 21v8zm2 0v-5l8-3v8h-8zM29 5.999h-8V20l8-3V5.999zM21 29v-5l8-3v8h-8z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "1",
  width: "29",
  height: "28"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 17V1h-8v19l8-3zm-9.99-6L9 17 .997 20v-9H9.01zM9 29H.997v-5L9 21v8zm2 0v-5l8-3v8h-8zM29 5.999h-8V20l8-3V5.999zM21 29v-5l8-3v8h-8z",
  fill: "currentColor"
}))));